/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/statusBanner.scss';

import React from 'react';

import {
    BolmateAutoEmailStatus,
    BolmateAutoUploadStatus,
    BolmateBolConnectionStatus,
    BolmateEmailSetupCard,
    BolmateInvoiceDesignCard,
    BolmateInvoiceUploadCard,
    BolmateVatSetupCard
} from '../../controls';

import {StatusTileState} from '../../controls/statusTile/bolmateStatusTile';

/** What every tile in this banner needs, whichever status it reports: the light
 *  it shows and, when there is something to fix, where that leads. One prop per
 *  tile instead of a pair that grows with each one. */
export interface StatusTileControl {
    state: StatusTileState;
    onClick?: () => void;
}

/** What every setup card needs: whether its step is behind it, where the card
 *  leads, and the corner check that is what actually completes it. Same
 *  one-prop-per-element shape as the tiles above. */
export interface SetupCardControl {
    completed: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
}

interface Props {
    bolConnection: StatusTileControl;
    autoEmail: StatusTileControl;
    autoUpload: StatusTileControl;
    /** The whole setup row drops out once it has nothing left to ask for. */
    showSetupCards: boolean;
    invoiceDesign: SetupCardControl;
    vatProducts: SetupCardControl;
    emailSetup: SetupCardControl;
    invoiceUpload: SetupCardControl;
}

export default function StatusBanner(props: Props) {
    const {
        bolConnection,
        autoEmail,
        autoUpload,
        showSetupCards,
        invoiceDesign,
        vatProducts,
        emailSetup,
        invoiceUpload
    } = props;

    function renderSetupCards() {
        if (!showSetupCards) return null;
        return (
            <div className='status-banner-cards'>
                <BolmateInvoiceDesignCard {...invoiceDesign} />
                <BolmateVatSetupCard {...vatProducts} />
                <BolmateEmailSetupCard {...emailSetup} />
                <BolmateInvoiceUploadCard {...invoiceUpload} />
            </div>
        );
    }

    return (
        <div className='status-banner'>
            <div className='status-banner-tiles'>
                <BolmateBolConnectionStatus {...bolConnection} />
                <BolmateAutoEmailStatus {...autoEmail} />
                <BolmateAutoUploadStatus {...autoUpload} />
            </div>
            {renderSetupCards()}
        </div>
    );
}
